import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>&copy; Kacper Bąk {new Date().getFullYear()}</p>
        </footer>
    );
};

export default Footer;
